import React from "react";
import {ReactComponent as DraftIconSmall} from "../../../../images/state/edit_24.svg";
import {ReactComponent as ClockIconSmall} from "../../../../images/state/clock_24.svg";
import {ReactComponent as AcceptedExpertIconSmall} from "../../../../images/state/expert_24.svg";
import {ReactComponent as DeclineIconSmall} from "../../../../images/state/do_disturb_24.svg";
import {ReactComponent as PublishedIconSmall} from "../../../../images/state/check_circle_24.svg";

export const SmallStateIcon = (stateid, classname) => {
  switch(stateid) {
    case 1:
      return <DraftIconSmall className={classname}/>;
    case 2:
      return <ClockIconSmall className={classname}/>;
    case 3:
      return <AcceptedExpertIconSmall className={classname}/>;
    case 4:
      return <DeclineIconSmall className={classname}/>;
    case 5:
      return <ClockIconSmall className={classname}/>;
    case 6:
      return <PublishedIconSmall className={classname}/>;
    default:
      return <ClockIconSmall className={classname}/>;
  }
};

export const StateTextColor = stateid => {
  switch(stateid) {
    case 1:
      return "#778899";
    case 2:
      return "#007FBD";
    case 3:
      return "#FF9500";
    case 4:
      return "#F15454";
    case 5:
      return "#007FBD";
    case 6:
      return "#85C446";
    default:
      return "#000000";
  }
};
